import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { SeoComponent } from '@shared/components';
import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { WindowService } from '@shared/window/window.service';
import { tap } from 'rxjs/operators';
import { BannerComponent } from '../components/banner/banner.component';
import { ConfiguratorComponent } from '../components/configurator/configurator.component';
import { NewArrivalsComponent } from '../components/new-arrivals/new-arrivals.component';
import { BannerCtaComponent } from '../components/banner-cta/banner-cta.component';
import { OurProductsComponent } from '../components/our-products/our-products.component';
import { VideoComponent } from '../../shared/components/video/video.component';
import { OurShowroomComponent } from '../../shared/components/our-showroom/our-showroom.component';
import { OurPartnersLogosComponent } from '../../our-showroom/components/our-partners-logos/our-partners-logos.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BannerComponent,
        ConfiguratorComponent,
        NewArrivalsComponent,
        BannerCtaComponent,
        OurProductsComponent,
        VideoComponent,
        OurShowroomComponent,
        OurPartnersLogosComponent,
        TranslatePipe,
    ],
})
export class MainPageComponent extends SeoComponent implements OnInit, OnDestroy {
    private windowService = inject(WindowService);
    private routingTabTitleService = inject(RoutingTabTitleService);

    override ngOnInit(): void {
        super.ngOnInit();

        this.windowService.scrollTop();

        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap((title) => {
                        this.seoTitle$.next(title);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.MAIN_PAGE.description'));
                    }),
                )
                .subscribe(),
        );
    }
}
